import { PdLoadingState } from "./pd-loading-state/PdLoadingState.js";
//#region src/pd-loading-state/pd-loading-state.ts
/**
* @license
* Copyright (c) 2021 PD Progressive Development UG. All rights reserved.
*/
var tag = "pd-loading-state";
if (!customElements.get(tag)) customElements.define(tag, PdLoadingState);
//#endregion
export { PdLoadingState };
